import { render, staticRenderFns } from "./business-logo.vue?vue&type=template&id=bf96d45c"
import script from "./business-logo.vue?vue&type=script&lang=js"
export * from "./business-logo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports